document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-stint-unit]');
  if (!button) return;
  const chart = button.closest('[data-stint-chart]');
  if (!chart) return;
  const inches = button.dataset.stintUnit === 'in';
  chart.querySelectorAll('[data-stint-unit]').forEach((control) => {
    control.setAttribute('aria-pressed', String(control === button));
  });
  chart.querySelectorAll('[data-stint-cm]').forEach((cell) => {
    const cm = Number(cell.dataset.stintCm);
    cell.textContent = inches ? (cm / 2.54).toFixed(1) : cell.dataset.stintCm;
  });
  chart.querySelector('[data-stint-cm-note]').hidden = inches;
  chart.querySelector('[data-stint-in-note]').hidden = !inches;
});